import { mixed } from 'yup';

/**
 * Arrow functions have problems with generics.
 * @param value
 */
export function constantString<const T extends string>(value: T) {
  // TODO: consider to make it around string()
  return mixed({ check: (v): v is T => v === value });
}
